import {
  CButton, CModal, CModalBody, CModalHeader, CSpinner,
} from '@coreui/react';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import useGlobalSelectionsContext from '../../../core/hooks/useGlobalSelectionsContext';
import LineSelect from '../../PetitionFieldReport/PetitionFieldReportForm/LineSelect';
import { getProspects } from '../api.service';

const ProspectLinesModal = ({
  prospectIds, petition, show, onClose, onSubmit,
}) => {
  const { initiativeId, organizationId } = useGlobalSelectionsContext();
  const [prospects, changeProspects] = useState();
  const [prospectsLines, changeProspectsLines] = useState({});
  useEffect(() => {
    getProspects({
      initiative_id: initiativeId,
      organization_id: organizationId,
      ids: prospectIds,
    }).then(({ data }) => changeProspects(data.data));
    // eslint-disable-next-line
  }, []);

  const handleSelectProspectLine = (prospectId, lineNumber) => {
    changeProspectsLines((val) => ({ ...val, [prospectId]: lineNumber }));
  };

  return (
    <CModal size="lg" show={show} onClose={onClose}>
      <CModalHeader closeButton>
        <h4 className="mb-0">
          Select the signature line that each prospect signed on
        </h4>
      </CModalHeader>
      <CModalBody>
        {prospects ? (
          <>
            <LineSelect
              prospects={prospects}
              maxSignatures={Number(petition.max_signature_lines) || 100}
              prospectsLines={prospectsLines}
              onChange={handleSelectProspectLine}
            />

            <CButton
              color="primary"
              className="m-2"
              size="lg"
              onClick={() => onSubmit(prospectsLines)}
            >
              Submit
            </CButton>
          </>
        ) : <CSpinner color="primary" size="md" />}
      </CModalBody>
    </CModal>
  );
};

ProspectLinesModal.propTypes = {
  prospectIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  petition: PropTypes.shape({ max_signature_lines: PropTypes.number }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  show: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ProspectLinesModal;
